import { Injectable } from '@angular/core';

import { LogDeviceModel } from '../../models/log-device.model';
import { IProductsModel } from '../../models/products.model';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { RequestService } from '../request/request-onboarding.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { NavigationService } from '../navigation/navigation-onboarding.service';

/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Definición de la clase ProductsService, servicio para los productos
 *
 * *Defines ProductsService class, products service *
 */
export class BitacoraService {

  /**
   * Constructor de la clase
   *
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los servicios
   *
   * *Initialize method for services*
   *
   * @param {CopyService}    copyService    Injectable copyService service.
   * @param {RequestService} requestService Injectable abreCuentasService service.
   */
  constructor(
    private abreCuentasService: AbreCuentasService,
    private requestService: RequestService,
    private bioCatchService: BioCatchService,
    public navigationService: NavigationService,
  ) { }

  /**
   * Guarda el log del dispositivo en la bitácora de la apliación
   *
   * *Saves device log in app bitacora*
   *
   * @param {LogDeviceModel} devicePrint
   */
  saveDataInBitacora(eventName: string, isCSID = false, crypto = false) {
    try {
      const devicePrint = new LogDeviceModel();
      console.log('this.abreCuentasService.getproductSelected()', this.abreCuentasService.getproductSelected());
      const product_name = this.abreCuentasService.getproductSelected() ? this.abreCuentasService.getproductSelected().product_code : '';
      devicePrint.device = this.abreCuentasService.getDeviceInfo();
      const ipBiocatch = this.bioCatchService.getCurrentScoreIp();
      const frontmicro = 'onboarding-angular-fe';
      devicePrint.device.event_name = eventName;
      devicePrint.transaction = this.abreCuentasService.getTransactionInfo();
      devicePrint.transaction.transaction_type = frontmicro;
      devicePrint.device.ip = ipBiocatch;
      devicePrint.terms_type = eventName;
      this.requestService.saveDataInBitacora(devicePrint, isCSID, crypto)
        .then(() => eventName === 'exit_process' && this.navigationService.goToLoginPage())
        .catch(() => eventName === 'exit_process' && this.navigationService.goToLoginPage());
    } catch (error) { console.log(error); }
  }
}
